import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { DialogboxComponent} from '../dialogbox/dialogbox.component'


@Component({
  selector: 'app-dialoguebox',
  templateUrl: './dialoguebox.component.html',
  styleUrls: ['./dialoguebox.component.css']
})

export class DialogueboxComponent implements OnInit {
  fileNameDialogRef: MatDialogRef<DialogboxComponent>;
  animal: string;
  name: string;
  constructor(public dialog: MatDialog) { }

  ngOnInit() {  }
  
  openDialog() {
    this.fileNameDialogRef = this.dialog.open(DialogboxComponent,{ width: '250px'},);
    
    this.fileNameDialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      //this.animal = result;
    });
  }
  
}
